const audioPlayer = "_35sa1ukelaw";
const image = "_35si112jy7g";

export { audioPlayer, image };
import "./input.image.style.linaria.module.css";
//# sourceMappingURL=input.image.style.js.map
